import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import styles from './styles';
import {InstanceContextProvider} from './InstanceContext';
import {ResponsiveContextProvider} from './Context/ResponsiveContext';
import {UserContextProvider} from './Context/UserContext';
import {FiltersContextProvider} from './Context/FiltersContext';
import {LogHandlerContextProvider} from './Context/LogHandlerContext';
import AppGate from "./components/AppGate";
import axiosConfig from './config/axios.config';
import axios from 'axios';
import BaseRouteLanding from './components/LandingPages/BaseRouteLanding';
import SessionActivationErrorPage from './components/LandingPages/SessionActivationErrorPage';

const App = () => {

   const isUserAgentIE = () => {
    // Check the userAgent property of the window.navigator
    // UA here is used for User Agent
    const UA = window.navigator.userAgent;
    // check if IE 10 or older
    const msie = UA.indexOf('MSIE ');
      // check if IE 11
    const trident = UA.indexOf('Trident/');
    return (msie > 0 || trident > 0);
  }

  // check app version and clear cache if needed
  axios.get(axiosConfig.ssoApi + '/backend/rt/sso/app_version/xt_console')
  .then(res => {
    if (res.data && res.data.version && localStorage.appVersion) {
      if (localStorage.appVersion !== res.data.version) {
        localStorage.setItem('appVersion', res.data.version);
        if(!isUserAgentIE() && caches) {
          caches.keys().then(names => {
            for(let name of names) caches.delete(name)
          })
        }
        window.location.reload(true);
      }
    } else if (res.data && res.data.version) localStorage.setItem('appVersion', res.data.version)
  })
  .catch(err => console.error(err));

// https://developer.mozilla.org/en-US/docs/Web/API/Cache
  useEffect(() => {
    if (!isUserAgentIE()) {
      try {
        if (caches) {
          caches.keys().then(names => {
            for(let name of names) caches.delete(name)
          })
        }
      } catch (e) {
        console.log(e, "E")
      }
    }
  }, [])


  return (
   <Router>
    <ResponsiveContextProvider>
    <UserContextProvider>
      <div style={styles.mainContainer} className="containerMain">
        <InstanceContextProvider>
        <FiltersContextProvider>
          <LogHandlerContextProvider>
            <Switch>
              <Route
                exact path='/:instance/session_error'
                component={SessionActivationErrorPage}
              />
              <Route
                path="/:instance" component={props =>
                  <AppGate
                    {...props}
                  />
                }
              />
            </Switch>
          </LogHandlerContextProvider>
        </FiltersContextProvider>
        </InstanceContextProvider>
       </div>
       <Route exact path='/' component={BaseRouteLanding} />
    </UserContextProvider>
    </ResponsiveContextProvider>
  </Router>
  );
}

export default App;
